<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="p-0 mx-auto"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <v-img
                            :src="image.full_path"
                            :lazy-src="image.full_path"
                            aspect-ratio="1"
                            :key="image.id"
                    >
                    </v-img>
                    <p class="text-center mr-5">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "headerSize",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'a3-افقی',
                    value: 'officer',
                    full_path: require('../../../../public/media/site/office2/a3-افقی.jpg')
                },
                {
                    id: '2',
                    name: 'a4-افقی',
                    value: 'typography',
                    full_path: require('../../../../public/media/site/office2/a4-افقی.jpg')
                },
                {
                    id: '3',
                    name: 'a4-عمودی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/a4-عمودی.jpg')
                },
                {
                    id: '4',
                    name: 'a5-عمودی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/a5-عمودی.png')
                },
                {
                    id: '5',
                    name: 'a5-افقی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/a5 افقی.jpg')
                },
                {
                    id: '6',
                    name: 'a6-افقی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/a6-افقی.jpg')
                },
                {
                    id: '7',
                    name: 'a6-عمودی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/a6-عمودی.jpg')
                },
                {
                    id: '8',
                    name: 'b5-افقی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/b5-افقی.jpg')
                },
                {
                    id: '9',
                    name: 'b5-عمودی',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/b5 عمودی.jpg')
                },
                {
                    id: '10',
                    name: 'عمودی-a3',
                    value: 'picture',
                    full_path: require('../../../../public/media/site/office2/عمودیa3.jpg')
                },
            ],
            count: 1,
        }
    },
    methods: {
        select(e) {
            if (this.selectedImage.length >= this.count) {
                Swal.fire({
                    title: "خطا",
                    text: "شما فقط میتوانید " + this.count + " تصویر انتخاب کنید",
                    type: "error",
                    confirmButtonText: "باشه"
                });
                return false;
            }
            const md5 = $(e.target).parent().parent().find('input').attr('data-md5')
            if (this.selectedImage.includes(md5))
                this.selectedImage.splice(this.selectedImage.indexOf(md5), 1)
            else
                this.selectedImage.push(md5)

        },
    }
}
</script>

<style scoped>

</style>